// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 操作符枚举 枚举类
 * 操作符枚举
 */
export enum EnumOperator {
  /** 相等 : 相等 */
  Equal = 1,
  /** 不相等 : 不相等 */
  NotEqual = 2,
  /** 大于 : 大于 */
  Greater = 4,
  /** 大于等于 : 大于等于 */
  GreaterEqual = 8,
  /** 小于 : 小于 */
  Less = 16,
  /** 小于等于 : 小于等于 */
  LessEqual = 32,
  /** 在集合中 : 在集合中 */
  In = 64,
  /** 在区间中 : 在区间中 */
  Between = 128,
  /** 字符串包含 : 字符串包含 */
  Contains = 256
}

/**
 * 操作符枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumOperatorMD {
  private static items = [
    new EnumItemMD('Equal', 1, '相等', '相等'),
    new EnumItemMD('NotEqual', 2, '不相等', '不相等'),
    new EnumItemMD('Greater', 4, '大于', '大于'),
    new EnumItemMD('GreaterEqual', 8, '大于等于', '大于等于'),
    new EnumItemMD('Less', 16, '小于', '小于'),
    new EnumItemMD('LessEqual', 32, '小于等于', '小于等于'),
    new EnumItemMD('In', 64, '在集合中', '在集合中'),
    new EnumItemMD('Between', 128, '在区间中', '在区间中'),
    new EnumItemMD('Contains', 256, '字符串包含', '字符串包含')
  ];

  static getItem(enumItem: EnumOperator) {
    return this.items.find(item => item.name === EnumOperator[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
